var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64285 3.02994e-05C2.98157 3.02994e-05 0 3.18037 0 7.08573C0 10.9911 2.98157 14.1714 6.64285 14.1714C8.24244 14.1714 9.71227 13.5643 10.8608 12.5545L13.9026 15.799C14.1537 16.0669 14.5605 16.0669 14.8117 15.799C15.0628 15.5312 15.0628 15.0964 14.8117 14.8294L11.7699 11.5848C12.7166 10.3598 13.2858 8.79192 13.2858 7.08564C13.2858 3.18028 10.3041 3.02994e-05 6.64285 3.02994e-05ZM6.64285 1.37146C9.60941 1.37146 12 3.9214 12 7.08573C12 10.2501 9.60941 12.8 6.64285 12.8C3.67628 12.8 1.28571 10.2501 1.28571 7.08573C1.28571 3.9214 3.67628 1.37146 6.64285 1.37146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.6d37e1cd004f7cb44d6ff43e4826951f.svg";
export { ForwardRef as ReactComponent };